const menu = [
  {
    id: 1,
    title: 'english breakfast',
    category: 'breakfast',
    price: 15.99,
    img: 'https://i.guim.co.uk/img/media/a6795e6f75daa968c1154d4acedc091599c98474/0_299_4973_2984/master/4973.jpg?width=1200&quality=85&auto=format&fit=max&s=b641084777d2dedffc4dc6523078514d',
    desc: `I'm baby woke mlkshk wolf bitters live-edge blue bottle, hammock freegan copper mug whatever cold-pressed `,
  },
  {
    id: 2,
    title: 'vegetarian hamburger',
    category: 'lunch',
    price: 18.99,
    img: 'https://d27k8xmh3cuzik.cloudfront.net/wp-content/uploads/2018/12/og-for-street-food-in-sydney.jpg',
    desc: `vaporware iPhone mumblecore selvage raw denim slow-carb leggings gochujang helvetica man braid jianbing. Marfa thundercats `,
  },
  {
    id: 3,
    title: 'one and only milkshake',
    category: 'shakes',
    price: 6.99,
    img: 'https://i2.wp.com/www.jennysmatblogg.nu/app/uploads/sites/6/img_1072.jpg?ssl=1',
    desc: `ombucha chillwave fanny pack 3 wolf moon street art photo booth before they sold out organic viral.`,
  },
  {
    id: 4,
    title: 'european delight',
    category: 'breakfast',
    price: 20.99,
    img: 'https://simply-delicious-food.com/wp-content/uploads/2018/10/breakfast-board.jpg',
    desc: `Shabby chic keffiyeh neutra snackwave pork belly shoreditch. Prism austin mlkshk truffaut, `,
  },
  {
    id: 5,
    title: 'wrap of sweden',
    category: 'lunch',
    price: 22.99,
    img: 'https://assets.icanet.se/t_epi6imagevault,f_auto/imagevaultfiles/id_159499/cf_259/tunnbrodswrap-med-rakor-och-kikartsstomp-721621-li.jpg',
    desc: `franzen vegan pabst bicycle rights kickstarter pinterest meditation farm-to-table 90's pop-up `,
  },
  {
    id: 6,
    title: 'candy dream',
    category: 'shakes',
    price: 18.99,
    img: 'https://blog.abt.com/wp-content/uploads/2018/08/cake-shakes-15-feat.png',
    desc: `Portland chicharrones ethical edison bulb, palo santo craft beer chia heirloom iPhone everyday`,
  },
  {
    id: 7,
    title: 'breakfast wrap',
    category: 'breakfast',
    price: 8.99,
    img: 'https://www.tasteofhome.com/wp-content/uploads/2018/01/Breakfast-Wraps_EXPS_TOHPP19_35683_B08_23_6b-6.jpg',
    desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
  },
  {
    id: 8,
    title: 'america',
    category: 'lunch',
    price: 12.99,
    img: 'https://assets.biggreenegg.eu/app/uploads/2017/12/05133526/topimage-mango-filled-hamburgers-800x500-600x375.jpg',
    desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
  },
  {
    id: 9,
    title: 'quarantine buddy',
    category: 'shakes',
    price: 16.99,
    img: 'https://drinkingwithpaul.com/wp-content/uploads/2020/04/quarantine_drinking.png',
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
];
export default menu;